// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: system-ui, -apple-system;
    --background-color-hover: rgba(128, 128, 128, 0.25); 
}

html, body {
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.288);
}
body {
    display: flex;
    justify-content: center;
    align-items: center;
}

#app {
    border: 1px rgba(0, 0, 0, 0.25) solid;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);
    display: flex;
    flex-direction: row;
    border-radius: 6px;
    height: 100%;
    width: 100%;
    background-color: white;
    z-index: 1;
    object-fit: contain;
    overflow-x: auto;
}
@media only screen and (max-width: 600px) {
    #app {
        gap: 3%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,qCAAqC;IACrC,mDAAmD;AACvD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sCAAsC;AAC1C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI;QACI,OAAO;IACX;AACJ","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    font-family: system-ui, -apple-system;\n    --background-color-hover: rgba(128, 128, 128, 0.25); \n}\n\nhtml, body {\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.288);\n}\nbody {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#app {\n    border: 1px rgba(0, 0, 0, 0.25) solid;\n    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);\n    display: flex;\n    flex-direction: row;\n    border-radius: 6px;\n    height: 100%;\n    width: 100%;\n    background-color: white;\n    z-index: 1;\n    object-fit: contain;\n    overflow-x: auto;\n}\n@media only screen and (max-width: 600px) {\n    #app {\n        gap: 3%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
